

























































































// Vue
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// Models
import { AuthUser } from "@/core/_models/authUser.model";
import { ClientModel, DaysOfWeek } from "@/core/api/apiClient";
// Services
import AdminService from "./Admin.service";
// Components
import DaysSelector from "@/core/components/content/DaysSelector.vue";

export default Vue.extend({
  name: "Settings",

  components: { DaysSelector },

  data() {
    return {
      isLoading: false,
      isConfirmed: false,

      name: "",
      companyLogo: "",
      mainThemeColor: "",
      myFile: null as File | null,
      workingDays: [] as DaysOfWeek[]
    };
  },

  mixins: [validationMixin],

  validations: {
    mainThemeColor: { required },
    workingDays: { required }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions("appMessages", {
      ADD_SUCCESS_MESSAGE: "ADD_SUCCESS_MESSAGE"
    }),

    initialize(): void {
      const currentUser = this.currentUser as AuthUser;
      
      this.name = currentUser.client!.name ?? "";
      this.companyLogo = currentUser.client!.companyLogoUrl ?? "";
      this.mainThemeColor = currentUser.client!.mainThemeColor ?? "#f60039";
      this.workingDays = currentUser.client!.workingDays ?? Object.values(DaysOfWeek);
    },

    async submit(): Promise<void> {
      const currentUser = this.currentUser as AuthUser;

      this.isLoading = true;

      // Build payload
      const payload = new ClientModel({
        clientId: currentUser.client!.clientId,
        name: this.name,
        companyLogoUrl: this.companyLogo,
        mainThemeColor: this.mainThemeColor,
        mainThemeTextColor: "#FFFFFF",
        jobSchedulerTimeIntervals: currentUser.client!.jobSchedulerTimeIntervals,
        workingDays: this.workingDays
      });

      // upload new logo
      if (this.myFile) {
        const uploadFile = this.myFile;

        const updateLogoResponse = await AdminService.updateClientLogo(
          currentUser.client!.clientId,
          uploadFile
        );

        payload.companyLogoUrl = updateLogoResponse?.companyLogoUrl;
      }

      // update client
      await AdminService.updateClient(currentUser.clientId!, payload);

      // update current app settings
      this.$vuetify.theme.themes.light.primary = this.mainThemeColor;
      currentUser.client!.mainThemeColor = this.mainThemeColor;

      currentUser.client!.workingDays = this.workingDays;

      if (payload.companyLogoUrl) {
        currentUser.client!.companyLogoUrl = payload.companyLogoUrl;
        this.companyLogo = payload.companyLogoUrl;
      }

      this.isConfirmed = false;
      this.isLoading = false;
      this.ADD_SUCCESS_MESSAGE(`Settings successfully updated.`);
    },

    close(): void {
      this.name = "";
      this.companyLogo = "";
      this.mainThemeColor = "";
      this.myFile = null;
    }
  },

  computed: {
    ...mapGetters({ currentUser: "currentUser" })
  }
});
